/**
 * Vorschau der Uebertragung (D-22/D-25): zeigt die Zeilen des Server-Endpunkts unveraendert als
 * monospace-Block, darunter der Hinweis auf leer uebertragene, gesperrte Werte. Keine eigene
 * Berechnung -- Zeilen und Zaehler kommen 1:1 aus `TransferPreview` (39-07/39-08).
 */
import type { CSSProperties } from 'react';
import { statusPalette } from '../../theme/colors';
import type { TransferPreview as TransferPreviewData } from '../../types/evaluationTable';
import classes from './evaluationTable.module.css';

const previewColorVars = {
  '--eval-preview-note-color': statusPalette.fehler.fg,
} as CSSProperties;

function wordForm(count: number, singular: string, plural: string): string {
  return count === 1 ? singular : plural;
}

function previewNote(
  omittedCurrent: number,
  omittedPrevious: number
): string | null {
  if (!omittedCurrent && !omittedPrevious) {
    return null;
  }
  const currentPart = `${omittedCurrent} ${wordForm(omittedCurrent, 'gesperrter Wert', 'gesperrte Werte')} dieses Zeitraums`;
  const previousPart = omittedPrevious
    ? `, ${omittedPrevious} im Vorjahr ${wordForm(omittedPrevious, 'gesperrter Vorjahreswert', 'gesperrte Vorjahreswerte')}`
    : '';
  return `Nicht übertragen: ${currentPart}${previousPart}.`;
}

export interface TransferPreviewProps {
  preview: TransferPreviewData;
}

export function TransferPreview({ preview }: TransferPreviewProps) {
  const note = previewNote(preview.omittedCurrent, preview.omittedPrevious);

  return (
    <div style={previewColorVars}>
      <pre className={classes.previewBlock}>{preview.lines.join('\n')}</pre>
      {note && <span className={classes.previewNote}>{note}</span>}
    </div>
  );
}
